import React from 'react';
import ApexChart from "react-apexcharts";
import dayjs from 'dayjs';
import { Series } from '../Dashboard/Dashboard';
import i18n from "i18next";

const BarChart = (props: { series: Series[], compare?: Series[] }) => {
  const dates = props.series.map(series => dayjs(series.date).format("ll"));
  const values = props.series.map(series => series.amount);

  const compareValues = props.compare?.map(s => Math.max(s.amount, 0.05)) ?? values.map(() => 0.05);
  const actualValues = values.map(val => val === 0 ? null : val);

  const maxValue = Math.max(
    ...compareValues,
    ...actualValues.map(v => v ?? 0)
  );

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: { show: false },
      background: 'transparent',
      sparkline: { enabled: true },
      offsetY: -5
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: dates,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      show: false,
      min: 0,
      max: maxValue
    },
    grid: { show: false },
    legend: { show: false },
    fill: { opacity: 1 },
    plotOptions: {
      bar: {
        columnWidth: 6
      }
    },
    tooltip: {
      y: {
        formatter: (value) => `${value === 0.05 ? 0 : value}`
      }
    },
    colors: ['var(--color-greyDark)', 'var(--color-purple)'],
  };

  const series = [
    {
      name: 'Solutions',
      data: compareValues
    },
    {
      name: 'Solutions',
      data: actualValues
    }
  ];

  return (
    <ApexChart
      height={90}
      options={options}
      series={series}
      type="bar"
    />
  );
};

export default BarChart;